// extracted by mini-css-extract-plugin
export default {"DocEditor":"DocEditor_DocEditor__gyY2T","body":"DocEditor_body__AE4yU","editWrapper":"DocEditor_editWrapper__F-2uz"};